/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MoreCircleIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'More Circle',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2ZM9.02 21.391A3.391 3.391 0 1 1 12.411 18a3.391 3.391 0 0 1-3.391 3.391Zm8.981 0A3.391 3.391 0 1 1 21.391 18 3.392 3.392 0 0 1 18 21.391Zm8.822 0A3.391 3.391 0 1 1 30.214 18a3.391 3.391 0 0 1-3.391 3.391Z"
    />
  </svg>`;
};
